/**
 * MAP-608: every background task that produces a new smap owns a complete set
 * of notification sentences under its own `SMAP_TASKS.<TASK>` namespace, so
 * PDF file conversion never borrows SMAP archive importation wording.
 *
 * Only the KEY is composed here, never the sentence: translators always see one
 * whole sentence per task, so word order and grammar stay per-language.
 * Adding a future task (CSV, Markdown, ...) is additive: add a `SMAP_TASKS.*`
 * block to the catalog plus one entry below, and change no call site.
 */
export type SmapTaskKind = 'pdfConversion' | 'smapImport';

export type SmapTaskString =
  /** Loading card shown while the source file is being uploaded. */
  | 'UPLOADING'
  /** Blue "you can keep working" card shown once the job is queued. */
  | 'IN_PROGRESS_INFO'
  /** Fallback body when the request that starts the job fails outright. */
  | 'START_FAILED'
  /** Title of every failure notification for this task. */
  | 'FAILED_TITLE'
  /** Fallback body when the job itself fails without a usable backend message. */
  | 'FAILED_DEFAULT'
  /** Title of the completion notification. */
  | 'SUCCESS_TITLE'
  /** Body of the completion notification. */
  | 'SUCCESS_MESSAGE';

export const SMAP_TASK_I18N_NAMESPACE: Record<SmapTaskKind, string> = {
  pdfConversion: 'SMAP_TASKS.PDF_CONVERSION',
  smapImport: 'SMAP_TASKS.SMAP_IMPORT',
};

export function smapTaskKey(kind: SmapTaskKind, part: SmapTaskString): string {
  return `${SMAP_TASK_I18N_NAMESPACE[kind]}.${part}`;
}
